import { can as canDo, type Capability } from '@/lib/permissions';
import { useAuthStore } from '@/store/auth.store';
import type { Role } from '@/types/domain';

export function useRole(): { role: Role | null; can: (cap: Capability) => boolean } {
  const role = useAuthStore((s) => s.user?.role ?? null);
  return {
    role,
    can: (cap: Capability) => canDo(role, cap),
  };
}
